module.exports = __webpack_public_path__ + "static/img/ls36.2568f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls36.png
// module id = VKwp
// module chunks = 12